import axios from 'axios';
export default axios.create({
    baseURL: process.env.VUE_APP_API_URL_EXAMEN_NIVELANDO,
    withCredentials: true,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Access-Control-Allow-Headers': 'X-Requested-With, Content-Type, X-Token-Auth, Authorization'
    }
});